import { render, staticRenderFns } from "./promiseGoodsWrhstReg.vue?vue&type=template&id=160029df"
import script from "./promiseGoodsWrhstReg.vue?vue&type=script&lang=js"
export * from "./promiseGoodsWrhstReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports